import { useState } from "react";
import { getApiBaseUrl, saveToken } from "../api/utils"

const API_URL = getApiBaseUrl();

export function OTPScreen({ phoneNumber, onVerify }) {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleVerify = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${API_URL}/auth/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile_number: phoneNumber, otp }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Verification failed");

      // localStorage.setItem("token", data.access_token);
      saveToken(data.access_token)
      onVerify();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-sm mx-auto">
      <h2 className="text-2xl font-semibold mb-4">Enter OTP</h2>
      <p className="mb-2 text-gray-600 text-sm">Sent to {phoneNumber}</p>

      <input
        type="text"
        placeholder="Enter OTP"
        className="border p-2 w-full mb-3"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
      />

      {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

      <button
        onClick={handleVerify}
        disabled={loading}
        className="bg-purple-600 text-white px-4 py-2 w-full rounded"
      >
        {loading ? "Verifying..." : "Verify OTP"}
      </button>
    </div>
  );
}
